/* SPDX-License-Identifier: AGPL-3.0-or-later */

import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  CopyLinkDialogComponent,
  CopyLinkDialogData,
} from '../components/copy-link-dialog/copy-link-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class CopyLinkService {
  matDialog = inject(MatDialog);

  /*
   * Opens a dialog and prompts the user to copy a given link.
   * @param data dialog data to use
   */
  openDialog(data: CopyLinkDialogData): void {
    this.matDialog.open(CopyLinkDialogComponent, {
      width: '750px',
      maxWidth: '900px',
      data,
    });
  }
}
